import { render, staticRenderFns } from "./PayCardImage.vue?vue&type=template&id=526c6846&scoped=true"
import script from "./PayCardImage.vue?vue&type=script&lang=ts"
export * from "./PayCardImage.vue?vue&type=script&lang=ts"
import style0 from "./PayCardImage.vue?vue&type=style&index=0&id=526c6846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c6846",
  null
  
)

export default component.exports